<template>
	<v-card>
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">Azione in massa: Stato Fasi</span>
		</v-card-title>
		<v-card-text>
			<v-row class="mt-4">
				<v-col>
					<template v-for="(faseWithStati) in computedFasiWithStati">
						<v-select
							v-model="idsStatiFasiSelezionati[`id_stato_fase_${faseWithStati.ordinamento}`]"
							@change="onChangeStatoFase($event, faseWithStati)"
							:items="faseWithStati.stati"
							item-text="nome"
							item-value="id"
							:label="`Stato fase ${faseWithStati.ordinamento} - ${faseWithStati.nome}`"
							hide-details
							class="mb-3"
							clearable
							outlined
							dense
						></v-select>
					</template>
				</v-col>
			</v-row>
			
			<!--<v-row>-->
			<!--	<v-col>-->
			<!--		<v-textarea-->
			<!--			v-model="descrizioneScreenshotInvio"-->
			<!--			label="Descrizione Screenshot Schermata del Click"-->
			<!--			outlined-->
			<!--			dense-->
			<!--		></v-textarea>-->
			<!--	</v-col>-->
			<!--</v-row>-->
			
			<v-row class="mt-0">
				<v-col>
					<v-checkbox
						v-model="inviaEmailAlCliente"
						label="Inviare email al Cliente?"
						hide-details
						class="mt-0"
					></v-checkbox>
				</v-col>
				<v-col>
					<v-checkbox
						v-model="inviaEmailAlReferente"
						label="Inviare email al Referente?"
						hide-details
						class="mt-0"
					></v-checkbox>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col>
					Se il Cliente e il Referente hanno lo stesso indirizzo email, verrà inviata una sola email
				</v-col>
			</v-row>
			
			<!--<pre>{{ fasiWithStati }}</pre>-->
			
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				@click="close()"
				:disabled="running"
				class="black--text"
			>
				Annulla
			</v-btn>
			<!-- Il tasto sarà attivo se c'è almeno un valore fra le chiavi di idsStatiFasi-->
			<!-- TODO: devo modificare la logica perchè ora sto aggiungendo -->
			<v-btn
				color="secondary"
				@click="run()"
				:loading="running"
				:disabled="!Object.values(idsStatiFasiSelezionati).some(val => val !== null)"
			>
				Esegui
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {mapGetters} from "vuex";
export default {
	props: ['praticheIds'],
	data() {
		return {
			idsStatiFasiSelezionati: {
				// id_stato_fase_x: null,
				// ...
			},
			ciSonoAggiornamentiFasi: {
				// ci_sono_aggiornamenti_fase_x: false
			},
			// descrizioneScreenshotInvio: null,
			listaModificheDaInviarePerEmail: [
				/**
				 * {
				 * 	titolo: null,
				 * 	campi: [],
				 * 	files: []
				 * }
				 */
			],
			inviaEmailAlCliente: false,
			inviaEmailAlReferente: false,
			running: false
		}
	},
	
	computed: {
		...mapGetters({
			/**
			 * Metto un esempio della struttura dell'oggetto fasiWithStati; l'oggetto principale è la fase, poi c'è l'array con gli stati
			 * [
			 *   {
			 *     "id": 31,
			 *     "bando_id": 29,
			 *     "ordinamento": 1,
			 *     "nome": "CARICA I DATI<br>DELLA PRATICA",
			 *     "descrizione": "<p>In questa sezione dovrai caricare i documenti e i dati che ti sono stati richiesti dal tuo Account Manager.</p><p></p><p></p>",
			 *     "created_at": "2025-01-24T18:20:00.000000Z",
			 *     "updated_at": "2025-01-24T18:20:00.000000Z",
			 *     "stati": [
			 *       {
			 *         "id": 92,
			 *         "fase_id": 31,
			 *         "ordinamento": 1,
			 *         "nome": "IN ATTESA DI DOCUMENTI",
			 *         "descrizione": "<p>Una volta che hai a disposizione tutti i dati e documenti necessari ovvero il Modulo di Riepilogo, il Modulo Codice Clickday e il Contratto di Servizio, <strong>ti preghiamo di caricarli qui</strong>. <br><br>Ricordati di inserire anche i dati utili ovvero la PEC primaria associata alla domanda, l'indicazione se la PEC sia abilitata o meno alla ricezione di email ordinarie e il numero di emergenza da contattare in caso di emergenza il giorno del Clickday. <br><br>Per procedere, <strong>fai clic sul riquadro corrispondente</strong> e allega il file pertinente e inserisci i dati richiesti. Una volta che avremo ricevuto i tuoi documenti e dati, <strong>li esamineremo entro al massimo 15 giorni</strong> e ti invieremo una notifica di conferma<strong>.</strong> <br>Nel caso in cui si presentino eventuali problemi, riceverai un'email in cui ti spiegheremo cosa fare.</p>",
			 *         "codice_colore": "#2196F3",
			 *         "controllo_campi_non_compilati_abilitato": false,
			 *         "imposta_quando_si_carica_screenshot_dal_simulatore": false,
			 *         "created_at": "2025-01-24T18:26:00.000000Z",
			 *         "updated_at": "2025-01-24T18:26:00.000000Z"
			 *       },
			 *       {
			 *         "id": 93,
			 *         "fase_id": 31,
			 *         "ordinamento": 2,
			 *         "nome": "FASE COMPLETATA: DOCUMENTI VALIDATI",
			 *         "descrizione": "<p><span style=\"font-size: 16px\"><strong>Grazie per aver caricato correttamente i documenti, per il momento non sono necessarie altre azioni da parte tua.<br></strong></span><br>Il tuo Account Manager procederà all'estrazione dei dati necessari e, non appena le regole tecniche saranno disponibili, ti assegneremo il cliccatore. <br>Al punto 2, troverai un riepilogo completo dei tuoi dati non appena verranno caricati dal tuo Account Manager.</p><p></p><p></p>",
			 *         "codice_colore": "#4CAF50",
			 *         "controllo_campi_non_compilati_abilitato": true,
			 *         "imposta_quando_si_carica_screenshot_dal_simulatore": false,
			 *         "created_at": "2025-01-24T18:26:00.000000Z",
			 *         "updated_at": "2025-01-24T18:26:00.000000Z"
			 *       }
			 *     ]
			 *   },
			 *   {
			 *     contenuto della fase successiva...
			 *   },
			 *   altre fasi...
			 * ]
			 */
			fasiWithStati: 'fasi/fasiWithStati'
		}),
		// faccio una computed per rimuovere il <br> che ho messo in alcuni nomi delle fasi e restituisco un nuovo oggetto
		computedFasiWithStati() {
			let fasiWithStati = [];
			this.fasiWithStati.forEach(faseWithStati => {
				let fws = Object.assign({}, faseWithStati);
				fws.nome = fws.nome.replace('<br>', ' ');
				fasiWithStati.push(fws);
			});
			return fasiWithStati;
		}
	},
	
	created() {
		/**
		 * Creo gli oggetti idsStatiFasi e ciSonoAggiornamentiFasi in modo dinamico perchè per ogni bando c'è un diverso
		 * numero di fasi; dentro gli oggetti ci sono le varie chiavi come `id_stato_fase_${fase.ordinamento}` tutte
		 * settate a null;
		 */
		this.fasiWithStati.forEach(fase => {
			this.$set(this.idsStatiFasiSelezionati, `id_stato_fase_${fase.ordinamento}`, null);
			this.$set(this.ciSonoAggiornamentiFasi, `ci_sono_aggiornamenti_fase_${fase.ordinamento}`, null);
		})
	},
	
	watch: {
		// praticheIds(oldVal, newVal) {
		// 	console.log('watch praticheIds oldVal', oldVal);
		// 	console.log('watch praticheIds newVal', newVal);
		// }
		// idsStatiFasi: {
		// 	handler(newVal) {
		// 		console.log(newVal);
		// 	},
		// 	deep: true
		// }
	},
	
	methods: {
		onChangeStatoFase(idStato, faseWithStati) {
			this.setCiSonoModificheFase(idStato, faseWithStati.ordinamento);
		},
		setCiSonoModificheFase(idStato, ordinamento) {
			this.ciSonoAggiornamentiFasi[`ci_sono_aggiornamenti_fase_${ordinamento}`] = idStato !== null;
		},
		run() {
			this.running = true;
			
			let idsStatiFasi = {};
			let listaModificheDaInviarePerEmail = [];
			
			for (const key in this.idsStatiFasiSelezionati) {
				const idStato = this.idsStatiFasiSelezionati[key];
				if (idStato !== null) {
					idsStatiFasi[key] = idStato;
					
					let ordinamentoFase = key.match(/\d+/)[0];
					const fase = this.computedFasiWithStati.find(fase => fase.ordinamento == ordinamentoFase);
					
					listaModificheDaInviarePerEmail.push({
						titolo: `Fase ${ordinamentoFase} ${fase.nome}`,
						campi: [
							`Stato aggiornato: ${fase.stati.find(stato => stato.id == idStato).nome}`
						],
						files: []
					})
				}
			}
			
			let ciSonoAggiornamentiFasi = {};
			for (const key in this.ciSonoAggiornamentiFasi) {
				const boolean = this.ciSonoAggiornamentiFasi[key];
				if (boolean === true) ciSonoAggiornamentiFasi[key] = true;
			}
			
			axios.post('/api/pratiche/mass-update', {
				pratiche_ids: this.praticheIds,
				ids_stati_fasi: idsStatiFasi,
				ci_sono_aggiornamenti_fasi: ciSonoAggiornamentiFasi,
				lista_modifiche_da_inviare_per_email: listaModificheDaInviarePerEmail,
				invia_email_al_cliente: this.inviaEmailAlCliente,
				invia_email_al_referente: this.inviaEmailAlReferente
			})
				.then(response => {
					this.close();
					this.$emit('done');
				})
				.finally(() => {
					this.running = false;
				})
		},
		close() {
			this.$emit('close');
		}
	}
}
</script>